/**
 * Maps Kazakh (KZ) voice tariff values to Russian (RU) for matching against API tariff names.
 * Voice prompt uses KZ: tariff_type (Экспресс / Магистральдық экспресс / Сәлемдеме),
 * tariff_from/tariff_to (Есік / Қойма). Tariff API returns names in RU, so we normalize KZ → RU.
 */

const TARIFF_TYPE_KZ_TO_RU = {
  экспресс: "экспресс",
  магистральдық: "магистральный",
  сәлемдеме: "посылка",
};

const DOOR_WAREHOUSE_KZ_TO_RU = {
  есік: "дверь",
  қойма: "склад",
};

function normalizeKey(s) {
  return (s || "").trim().toLowerCase();
}

/**
 * Map a single KZ term (door/warehouse) to RU.
 * @param {string} value - e.g. "Есік", "Қойма"
 * @returns {string} - e.g. "дверь", "склад"
 */
export function mapKZDoorWarehouseToRU(value) {
  const key = normalizeKey(value);
  return DOOR_WAREHOUSE_KZ_TO_RU[key] ?? value;
}

/**
 * Map KZ tariff type (first word) to RU first word for API matching.
 * @param {string} vTariffType - e.g. "Магистральдық экспресс", "Сәлемдеме", "Экспресс"
 * @returns {string} - RU first word for comparison with tariff_name
 */
export function mapKZTariffTypeFirstWordToRU(vTariffType) {
  const firstWord = (vTariffType || "").split(/\s+/)[0];
  const key = normalizeKey(firstWord);
  return TARIFF_TYPE_KZ_TO_RU[key] ?? firstWord;
}

/**
 * Get RU values for voice tariff matching when language is KZ.
 * @param {{ v_tariff_type?: string, v_tariff_from?: string, v_tariff_to?: string }} voiceTariff
 * @returns {{ typeFirstWord: string, fromTo: string }} - values to compare with tariff_name (RU)
 */
export function voiceTariffKZToRU(voiceTariff) {
  const typeFirstWord = mapKZTariffTypeFirstWordToRU(voiceTariff?.v_tariff_type);
  const fromRU = mapKZDoorWarehouseToRU(voiceTariff?.v_tariff_from);
  const toRU = mapKZDoorWarehouseToRU(voiceTariff?.v_tariff_to);
  const fromTo = `${fromRU}-${toRU}`;
  return { typeFirstWord, fromTo };
}
